let jobTypeList = [
  "Local Move",
  "International Move",
  "Storage",
  "Custom Clearance",
];
export default jobTypeList;
